"use strict";
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
Object.defineProperty(exports, "__esModule", { value: true });
exports.calculateS = void 0;
const react_native_1 = require("@aws-amplify/react-native");
const BigInteger_1 = require("../BigInteger");
const calculateS = async ({ a, g, k, x, B, N: _, U, }) => {
    const result = await (0, react_native_1.computeS)({
        a: a.toString(16),
        g: g.toString(16),
        k: k.toString(16),
        x: x.toString(16),
        b: B.toString(16),
        u: U.toString(16),
    });
    return new BigInteger_1.BigInteger(result, 16);
};
exports.calculateS = calculateS;
